.nqkmmh0 {
  overflow: hidden;
}